import {DateTimeStamps} from "./common";

export type TuitionId = number
export type TuitionDueDate = string
export type TuitionAmount = number
export type TuitionProofOfPayment = number
export type TuitionOfficialReceipt = number
export type TuitionOfficialReceiptNumber = number
export type TuitionStatus = string
export type TuitionRemarks = string

export enum ContractStatus {
    PENDING = 'PENDING',
    PARTIAL = 'PARTIALLY PAID',
    APPROVAL = 'FOR APPROVAL',
    FULL = 'FULLY PAID',
    REJECTED = 'REJECTED',
    PULLOUT = 'PULL OUT'
}

export enum PaymentScheme {
    SPOT = 'Spot Cash',
    TWICE = '2 Payment',
    QUARTERLY = '4 Payment',
    CUSTOM = 'Others'
}

export enum PaymentMode {
    INITIAL = 'N/A',
    CHECK = 'Check',
    BANK = 'Bank',
}

export enum PaymentNotation {
    RESERVATION = 'Reservation',
    EXTENDED = 'Extension',
    SPECIAL = 'Special Request'
}

export enum PaymentType {
    RESERVATION = 'Reservation',
    PAYMENT = 'Payment'
}

export enum PaymentStatus {
    PENDING = 'PENDING',
    ACKNOWLEDGED = 'ACKNOWLEDGED',
    REJECTED = 'REJECTED',
    BOUNCED = 'BOUNCED CHECK'
}

export interface TuitionPayment {
    id: TuitionId;
    dueDate?: TuitionDueDate;
    amount?: TuitionAmount;
    paymentProof?: TuitionProofOfPayment;
    officialReceipt?: TuitionOfficialReceipt;
    officialReceiptNumber?: TuitionOfficialReceiptNumber;
    status: TuitionStatus;
    remarks: TuitionRemarks;
    paymentMode: string;
    isConfirmationLetterSent: boolean;
    createdAt?: DateTimeStamps;
    updatedAt?: DateTimeStamps;
}
